export default {"src":"/_next/static/media/MetalWeight-titanium.5dd3a8b5.svg","height":28,"width":32};